import React from 'react';
import { Dialog } from 'primereact/dialog';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import CabeceraCliente from '../CabeceraCliente';

export const FasesDialog = ({ visible, onCancel, data, cotizacion }) => {
    const detalles = Array.isArray(data?.detalles) ? data.detalles : [];

    return (
        <Dialog 
            header={`Fases de Cotización`} 
            visible={visible} 
            style={{ width: '80vw' }} 
            onHide={onCancel}
        >
            <div className="card">
                <CabeceraCliente cotizacion={cotizacion} />

                <div className="mb-3 border-top-1 surface-border pt-3">
                    <DataTable
                        value={detalles}
                        size="small"
                        showGridlines
                        stripedRows
                    >
                        <Column field="codigo" header="Artículo" />
                        <Column field="glosa" header="Descripción" />
                        <Column field="cantidad" header="Cantidad" />
                        <Column field="unidad" header="UM" />
                        <Column
                            field="precioLista"
                            header="Precio Lista"
                            body={(rowData) =>
                                (rowData.precioLista ?? 0).toLocaleString('es-CL', {
                                    style: 'currency',
                                    currency: 'CLP',
                                })
                            }
                        />
                        <Column
                            field="descuento"
                            header="Desc %"
                            body={(rowData) => rowData.descuento ?? 0}
                        />
                        <Column
                            field="total"
                            header="Total"
                            body={(rowData) =>
                                (rowData.total ?? 0).toLocaleString('es-CL', {
                                    style: 'currency',
                                    currency: 'CLP',
                                })
                            }
                        />
                        <Column field="almacen" header="Almacén" />
                    </DataTable>
                </div>
            </div>
        </Dialog>
    );
};